import { z } from 'zod';

export const basicInfoSchema = z.object({
  machine: z.string().min(1, 'Machine is required'),
  roaster: z.string().min(1, 'Roaster is required'),
  machineTypeId: z.string().min(1, 'Machine is required'),
  roasterId: z.string().optional(),
  targetDate: z.string().min(1, 'Target date is required'),
  time: z.string().min(1, 'Time is required'),
  internalNotes: z.string().optional(),
});

export type BasicInfoFormData = z.infer<typeof basicInfoSchema>;
